import React from 'react';
export function LinksBarSection() {
  return <div className="bg-gray-200 py-4 px-6 rounded-lg text-center font-bold text-sm md:text-base" data-id="element-4434">
      <div className="flex flex-wrap justify-center items-center gap-2 md:gap-4" data-id="element-4435">
        <a href="/QuoteEDMConsumables.html" className="text-navy hover:text-orange transition-colors" data-id="element-4436">
          Request Quote EDM Consumables
        </a>
        <span className="text-orange" data-id="element-4437">|</span>
        <a href="https://www.peakedm.com/uploaded/files/GFMS_EDM_Consumables_Catalog.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="text-navy hover:text-orange transition-colors" data-id="element-4438">
          EDM Consumables Catalog
        </a>
        <span className="text-orange" data-id="element-4439">|</span>
        <a href="59m7/agiecharmilles-edm.html" className="text-navy hover:text-orange transition-colors" data-id="element-4440">
          AgieCharmilles Wire EDM
        </a>
      </div>
    </div>;
}